import googleConfig from "../GoogleAdvert/googleConfig";

const getAdvertPosition = () => {
  const {
    screen_breakpoint_mobile,
    screen_breakpoint_tablet,
    adverts_position
  } = googleConfig;

  const windowWidth = window.innerWidth;

  if (
    windowWidth >= screen_breakpoint_mobile &&
    windowWidth < screen_breakpoint_tablet
  )
    return adverts_position[1];
  if (windowWidth < screen_breakpoint_mobile) return adverts_position[0];

  return adverts_position[2];
};

export default getAdvertPosition;
